import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';
import moduleValidation from './moduleValidation';

import * as ModuleActions from 'redux/modules/modules';

export const fields = ['name'];

import { translate } from 'react-i18next';

@translate(['common'])
@connect(
	state => ({
		created: state.modules.created,
		moduleCreatedError: state.modules.moduleCreatedError,
	}),
	dispatch => bindActionCreators(ModuleActions, dispatch)
)
@reduxForm({
	form: 'synchronousValidation',
	fields: fields,
	validate: moduleValidation
})
export default class CreateModuleForm extends Component {

	render() {
		const {
			fields: { name },
			formKey,
			handleSubmit,
			invalid,
			submitting,
			resetForm,
			createModule,
			values,
			moduleCreatedError,
			created,
			t
		} = this.props;

		const styles = require('containers/Modules/AddModule.scss');

		if (moduleCreatedError != false) {
			var error = (
				<div className="alert alert-danger" role="alert">
					<span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
					{moduleCreatedError}
				</div>);
		} else {
			var error = '';
		}

		if (created == true) {
			var success = (
				<div className="alert alert-success" role="alert">
					<span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
					{t('modules.module_created')}
				</div>);
		} else {
			var success = '';
		}

		return (
			<form className="form-horizontal" >
				<div className="col-xs-6">
					<div className={'form-group' + (name.touched && name.error ? ' has-error' : '')}>
						<label className="col-xs-2 control-label">
							{t('main.lastname')}
						</label>
						<div className={'col-xs-' + (name.touched && name.error ? '5' : '8')}>
							<input type="text" className="col-xs-8 form-control" {...name} />
						</div>
						{name.touched && name.error && <div className="col-xs-3 help-block">{name}</div>}
					</div>


					<div className="text-left">

						<button onClick={handleSubmit(() =>
							createModule(values.name)
						)} type="submit" className="btn btn-success" disabled={invalid || submitting}>
							<i className={'fa ' + (submitting ? 'fa-cog fa-spin' : 'fa-cloud')} /> &nbsp;
							{t('modules.create_the_mod')}
				  </button>

						<button type="button" className="btn btn-warning" style={{ margin: 10 }} disabled={submitting} onClick={resetForm}>
							Reset
	          			</button>
					</div>

					{error}

					{success}
				</div>
			</form>
		);
	}
}
